import { useQuery } from "@tanstack/vue-query";

import {
	type UnderwritingAgentTrace,
	UnderwritingAgentTraceSchema,
} from "@ca/types/traces";

import { client } from "@/api";



export const usePersistedAgentTraces = () => useQuery({
	queryFn: async () => {
		const actionsResp = await client.api.v1.admin["submissions-actions"].get({
			query: {
				source: "agent",
				offset: 0,
				limit: 1000,
			},
		});
		if (actionsResp.status !== 200) {
			return [];
		}
		const traces: UnderwritingAgentTrace[] = [];
		const actions = actionsResp.data?.actions ?? [];
		for (const action of actions) {
			const parsed = UnderwritingAgentTraceSchema.safeParse(action.payload);
			if (parsed.success) {
				traces.push(parsed.data);
			}
		}
		return traces;
	},
	queryKey: ["submission-actions", "agent"],
	refetchOnMount: true,
});
